<template>
  <div>
    <!-- tab content item -->
    <section class="wallet__cash__balances">
      <div class="cash__balances outer-container">
        <div class="panel">
          <div class="panel__header">
            <div class="panel__header__left">
              Your
              <span>Currency Balance</span>
            </div>
            <div class="panel__header__right">
              <a
                class="btn btn--default btn--schedule"
                title="create wallet"
                data-toggle="modal"
                data-target="#createWalletModal"
                v-if="enableActions"
              >
                <span>+</span>Add a currency
              </a>
            </div>
          </div> 
          <!-- added section with class and added class to the div that checks if the page is still loading in transition header -->
          <section class="panel wallet-balance">
            <div class="panel__content panel__content--grey outer-container">
              <div class="loaderContainer" v-if="isLoading">
                <img src="/static/wave.gif" alt width="32" height="32">
              </div>

              <transition name="slide-fade">
                <div v-if="!isLoading" class="wallets--lower overview__wallets wallet__cash__balance">
                  <!--individual cash balance-->
                  <div
                    class="cash__balance card"
                    v-for="currency in walletOverviewData.cashBalances.value"
                  >
                    <router-link
                      :to="{name: 'single-balance-details', params: { id: currency.id }}"
                      class="default-style"
                    >
                      <div class="card__content">
                        <!--if primary-->
                        <div class="cash__balance__tag hide">
                          <span class="cash__balance__tag__type">Primary</span>
                          <span class="tag--green tag--circle tag--circle--sm"></span>
                        </div>
                        <div class="cash__balance__amount">
                          <span class="cash__balance__currency">{{currency.currency.symbol}}</span>
                          {{ currency.balance | numeralize('0,0.00') }}
                        </div>
                        <div class="cash__balance__deets">
                          <div class="wallet__cash__flag-thumbnail">
                            <svg class="icon-flag icon--sm">
                              <use
                                v-bind="{'xlink:href':'/static/icons.svg#icon-flag-'+ toLowerCase(currency.currency.shortCode)}"
                              ></use>
                            </svg>
                          </div>
                          <div class="wallet__cash__name">{{currency.currency.shortCode}} balance</div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <!--add money-->
                  <div class="cash__balance card">
                    <div class="card__content card__content__empty">
                      <router-link :to="{name:'fund-wallet'}" class="btn btn--lg fund-wallet-text">
                        <span>
                          <svg
                            class="icon icon--md"
                            enable-background="new 0 0 512 512"
                            version="1.1"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m487.59 299.89h-7.662v-69.015c0-10.926-5.438-20.6-13.743-26.478v-9.397c0-13.631-11.089-24.72-24.72-24.72h-5.721l21.889-32.12c7.337-10.766 4.547-25.495-6.219-32.833l-148.53-101.22c-5.215-3.555-11.501-4.867-17.705-3.69-6.201 1.175-11.574 4.694-15.128 9.91l-128.2 188.12h-35.675l8.607-87.13c0.097-0.982 0.735-1.833 1.625-2.168 11.089-4.181 20.699-11.989 27.059-21.985 0.501-0.787 1.446-1.237 2.424-1.138l55.955 5.528c4.012 0.389 7.581-2.533 7.977-6.543s-2.533-7.581-6.543-7.977l-55.955-5.528c-6.495-0.636-12.689 2.357-16.169 7.825-4.676 7.35-11.742 13.09-19.895 16.164-6.137 2.314-10.351 7.826-10.999 14.387l-8.748 88.564h-9.303l13.612-137.8c0.49-4.96 4.917-8.604 9.883-8.107l113.07 11.17c4.01 0.387 7.581-2.533 7.977-6.543s-2.533-7.581-6.543-7.977l-113.07-11.17c-12.964-1.279-24.557 8.226-25.838 21.192l-10.972 111.07h-18.685c-13.63 0-24.72 11.089-24.72 24.72v6.41c-11.151 5.134-18.915 16.406-18.915 29.465v248.7c0 17.88 14.546 32.426 32.427 32.426h407.07c17.88 0 32.426-14.546 32.426-32.426v-69.014h7.662c9.044 0 16.401-7.357 16.401-16.4v-77.865c1e-3 -9.044-7.357-16.401-16.401-16.401zm-46.125-115.02c5.586-1e-3 10.129 4.543 10.129 10.129v3.717c-1.342-0.17-2.705-0.267-4.092-0.267h-30.955l9.253-13.579h15.665zm-159.36-166.33c1.36-1.995 3.415-3.341 5.787-3.791 0.567-0.107 1.136-0.161 1.701-0.161 1.797 0 3.553 0.538 5.071 1.572l148.53 101.22c4.118 2.807 5.186 8.441 2.38 12.559l-46.686 68.506h-11.204l22.889-33.587c3.712-5.447 4.018-12.379 0.796-18.092-4.282-7.59-6.018-16.527-4.888-25.166 0.84-6.427-1.988-12.701-7.38-16.375l-76.998-52.472c-5.393-3.675-12.267-4.012-17.941-0.879-7.625 4.21-16.578 5.863-25.208 4.655-6.4-0.898-12.891 1.992-16.548 7.357l-91.699 134.56h-11.204l122.6-179.91zm3.213 123.89c-31.771 0-57.851 24.773-59.976 56.015h-36.979l86.099-126.34h1e-3c0.489-0.719 1.3-1.147 2.133-1.147 0.111 0 0.222 8e-3 0.333 0.023 11.738 1.642 23.913-0.604 34.285-6.331 0.816-0.452 1.864-0.387 2.672 0.163l76.999 52.473c0.806 0.55 1.249 1.502 1.129 2.426-1.537 11.749 0.825 23.903 6.648 34.225 0.467 0.829 0.41 1.891-0.144 2.706l-28.488 41.804h-24.733c-2.127-31.241-28.206-56.014-59.979-56.014zm45.348 56.016h-90.695c2.09-23.189 21.624-41.424 45.347-41.424 23.724-1e-3 43.259 18.235 45.348 41.424zm-289.15-3.45c0-5.586 4.543-10.13 10.129-10.13h17.244l-1.341 13.579h-26.032v-3.449zm-18.915 35.875c0-9.834 8.001-17.835 17.836-17.835h407.07c9.835 0 17.835 8.001 17.835 17.835v20.244h-442.74v-20.244zm442.74 248.7c0 9.834-8 17.835-17.835 17.835h-407.07c-9.835 0-17.836-8.001-17.836-17.835v-20.244h39.342c4.03 0 7.295-3.266 7.295-7.295s-3.266-7.295-7.295-7.295h-39.342v-179.03h442.74v34.18h-69.367c-21.856 0-40.788 12.74-49.773 31.181-0.03 0.062-0.064 0.122-0.095 0.184-0.076 0.157-0.142 0.32-0.216 0.478-1.07 2.273-2 4.626-2.757 7.054-2e-3 7e-3 -4e-3 0.013-6e-3 0.02-1.615 5.189-2.486 10.702-2.486 16.416 0 30.511 24.822 55.333 55.332 55.333h69.367v34.18h-356.68c-4.03 0-7.295 3.266-7.295 7.295s3.266 7.295 7.295 7.295h356.68v20.244zm24.064-85.415c0 0.998-0.812 1.81-1.811 1.81h-91.618c-15.445 0-28.911-8.639-35.818-21.338-0.314-0.577-0.614-1.163-0.901-1.756-0.573-1.187-1.09-2.406-1.547-3.654-1.602-4.366-2.476-9.08-2.476-13.994s0.875-9.628 2.476-13.994c0.458-1.247 0.975-2.466 1.547-3.654 0.287-0.593 0.587-1.179 0.901-1.756 6.907-12.699 20.373-21.338 35.818-21.338h91.618c0.998 0 1.811 0.812 1.811 1.81v77.864z"
                            ></path>
                            <path
                              d="m397.68 325.63c-16.322 0-29.6 13.279-29.6 29.6s13.278 29.599 29.6 29.599 29.6-13.278 29.6-29.599-13.278-29.6-29.6-29.6zm0 44.608c-8.276 0-15.009-6.733-15.009-15.008s6.733-15.009 15.009-15.009 15.009 6.733 15.009 15.009-6.733 15.008-15.009 15.008z"
                            ></path>
                          </svg>
                        </span>
                        Topup
                      </router-link>
                    </div>
                  </div>
                </div>
              </transition>

              <!--if there are no wallet currencies-->
              <div class="panel__empty" v-if="!isLoading && walletOverviewData.cashBalances.empty">
                <div class="panel__empty__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70" viewBox="0 0 92 70">
                    <g fill="none" fill-rule="evenodd" transform="translate(-1 -1)">
                      <rect
                        width="43"
                        height="60"
                        x="10"
                        y="6"
                        fill="#D6DBEB"
                        opacity=".269"
                        rx="3"
                        transform="rotate(-22 31.5 36)"
                      ></rect>
                      <rect
                        width="43"
                        height="60"
                        x="41"
                        y="6"
                        fill="#D6DBEB"
                        opacity=".269"
                        rx="3"
                        transform="rotate(22 62.5 36)"
                      ></rect>
                      <g fill-rule="nonzero">
                        <g transform="translate(47 45)">
                          <path
                            fill="#4B536B"
                            d="M10.968.279a5.039 5.039 0 1 0 .001 10.077A5.039 5.039 0 0 0 10.968.28zm2.178 7.326c-.134.27-.32.495-.562.676a2.561 2.561 0 0 1-.859.408c-.13.037-.266.064-.404.086v.591h-.775v-.542a4.194 4.194 0 0 1-.562-.05 3.82 3.82 0 0 1-.569-.134 2.764 2.764 0 0 1-.418-.164 1.021 1.021 0 0 1-.244-.156.474.474 0 0 1-.118-.23 1.924 1.924 0 0 1-.042-.465c0-.135.004-.243.014-.324a.776.776 0 0 1 .042-.195c.019-.049.042-.082.069-.098a.21.21 0 0 1 .105-.024c.052 0 .127.029.227.087.101.058.225.122.374.191.149.071.322.135.52.195s.422.091.673.091c.159 0 .299-.015.422-.048s.23-.079.321-.14a.593.593 0 0 0 .207-.23.702.702 0 0 0 .069-.321.535.535 0 0 0-.128-.359 1.128 1.128 0 0 0-.343-.262 3.983 3.983 0 0 0-.481-.209 11.381 11.381 0 0 1-.552-.217 5.015 5.015 0 0 1-.55-.272 2.077 2.077 0 0 1-.482-.377 1.694 1.694 0 0 1-.341-.538 1.956 1.956 0 0 1-.13-.753c0-.297.058-.571.175-.82.116-.248.283-.461.503-.639.218-.176.485-.314.799-.412.14-.043.288-.077.443-.101v-.582h.775v.54a4.14 4.14 0 0 1 .907.143c.149.042.275.088.377.136.102.049.176.091.22.126a.315.315 0 0 1 .093.105.454.454 0 0 1 .043.126 2.556 2.556 0 0 1 .034.449c0 .126-.003.228-.01.307a.779.779 0 0 1-.035.189c-.016.045-.038.077-.065.093a.193.193 0 0 1-.098.025.484.484 0 0 1-.195-.073 3.307 3.307 0 0 0-.331-.157 4.035 4.035 0 0 0-.461-.157 2.205 2.205 0 0 0-.596-.073c-.159 0-.296.016-.412.049a.773.773 0 0 0-.286.14.61.61 0 0 0-.225.474c0 .145.044.266.134.363.088.098.204.184.349.258.144.076.307.145.491.21.184.064.37.136.558.213.189.077.375.166.559.268.183.102.348.228.491.377.145.149.261.327.349.534.088.207.132.452.132.736a2.148 2.148 0 0 1-.201.936z"
                          ></path>
                          <circle cx="2.34" cy="5.317" r="1.679" fill="#D6DBEB"></circle>
                          <circle cx="19.596" cy="5.317" r="1.679" fill="#D6DBEB"></circle>
                        </g>
                        <path
                          fill="#4B536B"
                          d="M72.194 41.635H43.742c-.785 0-1.421.563-1.421 1.257v14.852c0 .694.636 1.257 1.421 1.257h28.451c.785 0 1.421-.563 1.421-1.257V42.892c.001-.695-.635-1.257-1.42-1.257zM44.59 54.338v-7.357c.987-.009 3.28-.352 3.286-3.34h20.221c.017.994.381 3.197 3.25 3.247v7.377c-.963.036-2.84.409-3.122 2.729h-20.32c-.164-1.108-.837-2.65-3.315-2.656z"
                        ></path>
                        <g fill="#4B536B">
                          <path
                            d="M35.6 25.5h4.466v4.466H35.6zM43.615 25.5h4.466v4.466h-4.466zM51.631 25.5h4.466v4.466h-4.466zM27.584 32.291h4.466v4.466h-4.466zM27.584 25.5h4.466v4.466h-4.466zM35.6 32.291h4.466v4.466H35.6zM43.615 32.291h4.466v4.466h-4.466zM51.631 32.291h4.466v4.466h-4.466zM27.584 39.081h4.466v4.466h-4.466zM39.724 42.892c0-.553.123-1.079.342-1.554v-2.256H35.6v4.466h4.124v-.656z"
                          ></path>
                          <g>
                            <path
                              d="M31.147 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM41.873 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM52.599 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.67 1.488-1.488 1.488z"
                            ></path>
                            <path
                              d="M57.022 12.124h-1.079v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636H26.66c-4.563 0-8.274 3.712-8.274 8.274v20.375c0 4.563 3.712 8.274 8.274 8.274h13.064v-3.711H26.66a4.568 4.568 0 0 1-4.563-4.563V23.435h39.489v15.602h3.711V20.399c-.001-4.563-3.712-8.275-8.275-8.275z"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="panel__empty__text">
                  You have no wallet currencies.
                  <button class="btn btn--default">Add a wallet currency</button>
                </div>
              </div>
            </div>
          </section>
          
        </div>
      </div>
    </section>

    <!--card in wallet-->
    <section class="wallet__cards">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            Your
            <span>linked Cards</span>
          </div>
          <div class="panel__header__right">
            <button class="btn btn--default btn--sm" data-toggle="modal"
              v-if="enableActions"
              data-target="#createSureModal">
              <span>+</span>Link a card
            </button>
          </div>
        </div>
        <div class="panel__content panel__content--grey outer-container">
          <div class="loaderContainer" v-if="isLoading">
            <img src="/static/wave.gif" alt width="32" height="32">
          </div>
          <!--individual wallet cards-->
          <transition name="slide-fade">
            <div v-if="!isLoading">
              <div class="card card__wallet" v-for="card in walletOverviewData.linkedCards.value">
                <div class="card__content">
                  <div class="card__wallet--upper flex-box-ends">
                    <div v-if="card.card.cardType == 'master-card' " class="card-logo">
                      <img src="/static/mastercard.png" height="34" alt="mastercard">
                    </div>
                    <div class="card__wallet__disable" v-if="enableActions">
                      <button class="btn btn--flat btn--sm"
                      data-toggle="modal"
                      data-target="#createDeleteModal"
                      @click="getId(card.cardId)">Remove</button>
                    </div>
                  </div>
                  <div class="card__wallet--mid card__wallet--deets flex-box-ends">
                    <div class="card__masked-span">
                      {{card.card.first6digit}}
                      <span class="masked">******</span>
                      {{card.card.last4digit}}
                    </div>
                  </div>
                  <div
                    class="card__wallet--lower card__wallet__name"
                  >{{toLowerCase(card.card.issuer)}}    <span style="position: absolute; left: 75%; color: lightgreen;" v-if="card.enabled" > Enabled </span>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div
        class="modal fade"
        id="createWalletModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="createWalletModal"
      >
        <!-- Modal Dialog -->
        <div class="modal__dialog modal__dialog--xlg" role="document">
          <!-- Modal content -->
          <div class="modal__content">
            <div class="modal__header">
              <div class="modal__title">
                <span class="time-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 612 612"
                    style="enable-background:new 0 0 612 612;"
                    xml:space="preserve"
                    class="icon--sm"
                  >
                    <g>
                      <g>
                        <g>
                          <path
                            d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#576ae6"
                            fill="#576ae6"
                          ></path>
                          <path
                            d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#576ae6"
                            fill="#576ae6"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                Add a Currency Balance
              </div>
              <!-- Modal close button -->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <path
                    fill="#C0C6D8"
                    fill-rule="nonzero"
                    d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                  ></path>
                </svg>
              </button>
            </div>
            <!-- Modal Body -->
            <div class="modal__body modal__body--pad">
              <div class>
                <form action class="form disburse-form" @submit.prevent="createWalletHandler()">
                  <div class="form__item">
                    <label for="disburseSource" class="form__label--span form--left">
                      Balance
                      <span>name</span>
                    </label>
                    <div class="select form--right">
                      <input
                        type="text"
                        name="name"
                        placeholder
                        v-model="createObject.name"
                        id="walletName"
                        class="form__input input"
                        data-vv-id="1"
                        aria-required="true"
                        aria-invalid="false"
                      >
                    </div>
                  </div>
                  <!---->
                  <div class="form__item">
                    <label for="fundingDestination" class="form__label--span form--left">
                      <span>Currency</span>
                    </label>
                    <div class="select form--right">
                      <select
                        name="destination"
                        id="fundingDestination"
                        class="select__input"
                        data-vv-id="2"
                        v-model="createObject.countryTag"
                        aria-required="true"
                        aria-invalid="false"
                      >
                      <option disabled value>Select a Currency</option>
                      <option
                        v-for="currency in currencyList"
                        v-bind:value="currency.countryTag"
                      >{{ currency.shortCode }} - {{currency.currencyName}}</option>
                      </select>
                      <div class="select__icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="6"
                          height="10"
                          viewBox="0 0 6 10"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <!---->
                  <!---->
                  <!---->
                  <div class="form__item">
                    <label for="disburseAmount" class="form__label--span form--left">
                      <span>Password</span>
                    </label>
                    <div class="input form--right">
                      <input
                        type="password"
                        name="password"
                        autocomplete="new-password"
                        v-model="createObject.password"
                        placeholder
                        id="walletPassword"
                        class="form__input input"
                        data-vv-id="4"
                        aria-required="true"
                        aria-invalid="false"
                      >
                    </div>
                  </div>
                  <div class="form__item">
                    <label for="disburseAmount" class="form__label--span form--left">
                      <span>User Reference</span>
                    </label>
                    <div class="input form--right">
                      <input
                        type="text"
                        name="uref"
                        v-model="createObject.uref"
                        placeholder="Optional - required only for sub balances"
                        id="walletUref"
                        class="form__input input"
                        data-vv-id="3"
                        aria-required="true"
                        aria-invalid="false"
                      >
                    </div>
                  </div>
                  <div class="form__item disburse-form__submit" v-if="enableActions">
                    <button
                      id="fundWallet"
                      type="submit"
                      class="btn btn--primary btn--block"
                    >Create Balance</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal-template v-if="createDone">
      <div slot="header" class="display__inline-block">
        <div class="modal__title">
          New<span> Balance</span>
        </div>
      </div>
      <div slot="action-button" class="modal-default-button display__inline-block" @click="createDone = false">
        <button class="btn btn--default">Back</button>
      </div>

      <div slot="body">
        <div class="disburse__result text-center">
          <transition name="slide-fade">
            <div v-if="createSuccess">
              <!--success icon-->
              <div class="result-img">
                <svg class="icon icon--custom-big" enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="25" fill="#25AE88"/>
                <polyline points="38 15 22 33 12 25" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
              </svg>
              </div>
              <p class="disburse__result__success success-text">Balance created successfully!</p>
              <button class="btn btn--primary" @click="utilityMethods().triggerPageLoad()">See balances</button>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="createFailure">
              <div class="result-img">
                <svg enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" class="icon icon--custom-big">
                  <circle cx="25" cy="25" r="25" fill="#D75A4A"/>
                  <polyline points="16 34 25 25 34 16" fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                  <polyline points="16 16 25 25 34 34" fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
              </svg>
              </div>
              <p v-for="error in createErrors" class="disburse__result__error error-text">{{error}}</p>
              <button class="btn btn--primary" @click="utilityMethods().triggerPageRefresh()">Retry create</button>
              <button class="btn btn--default" @click="utilityMethods().triggerPageLoad()">See balances</button>
            </div>
          </transition>
        </div>
      </div>
    </modal-template>
    </section>
    <div
      class="modal fade"
      id="createSureModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createSureModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--lg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Link a new Card
            </div>
            <!-- Modal close button -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form
                action
                class="form disburse-form"
                @submit.prevent="handleLinkingCard()"
                v-if="linkingNotFinished"
              >
                <div class="form__item">
                  <label class="form__label--span form--left">
                    Card
                    <span>Number</span>
                  </label>
                  <div class="select form--right">
                    <cleave v-model="cardObject.cardNumber" :options="options" class="form__input input" name="card"></cleave>
                    <!-- <input
                      type="text"
                      placeholder="XXXX XXXX XXXX XXXX"
                      v-model="cardObject.cardNumber"
                      id="cardNumber"
                      class="input-credit-card"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    > -->
                  </div>
                </div>
                <div class="form__item">
                  <label class="form__label--span form--left">
                    Expiry
                    <span>Date</span>
                  </label>
                  <div class="select form--right">
                    <cleave v-model="cardObject.expiryDate" :options="options2" placeholder="MM/YY" class="form__input input" name="expiryDate"></cleave>
                    <!-- <datepicker :inputClass="'form__input input'" required :placeholder="'05/20'" v-model="cardObject.expiryDate" maximum-view="year" minimum-view="month" :value="cardObject.expiryDate"></datepicker> -->
                  </div>
                </div>
                <div class="form__item">
                  <label class="form__label--span form--left">
                    Card
                    <span>CVV</span>
                  </label>
                  <div class="select form--right">
                    <cleave v-model="cardObject.cvv" :options="options3" placeholder="XXX" class="form__input input" name="cvv"></cleave>
                    <!-- <input
                      type="number"
                      name="cvv"
                      placeholder = "123"
                      v-model="cardObject.cvv"
                      id="cvv"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    > -->
                  </div>
                </div>

                <div class="form__item">
                  <button
                    v-if="enableActions"
                    id="linkWallet"
                    type="submit"
                    class="btn btn--primary btn--block link_submit"
                  >Link your Card</button>
                </div>
              </form>

              <div class="disburse__result text-center" v-if="linkingDone">
                <div v-if="linkingSuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    class="disburse__result__success success-text"
                  >Card successfully sent for Approval!</p>
                  <button
                    class="btn btn--primary"
                    @click="utilityMethods().newLinking()"
                  >Link another Card</button>
                  <button
                    class="btn btn--default"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createSureModal"
                    @click="utilityMethods().triggerPageRefresh()"
                  >Finish</button>
                </div>

                <div v-if="linkingFailed">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                      <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    v-for="error in linkingErrors"
                    class="disburse__result__error error-text"
                  >{{error}}</p>
                  <button class="btn btn--primary"
                  @click="utilityMethods().newLinking('Retry')">Retry</button>
                  <button
                    class="btn btn--default"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createSureModal"
                    @click="utilityMethods().triggerPageRefresh()"
                  >See all linked card</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="createDeleteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createDeleteModal"
    >
      <div class="modal__dialog modal__dialog--sm">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Remove Card
            </div>
          </div>

          <div
            class="modal__body"
            style="padding: 40px 10px 30px 10px; display:flex; flex-direction: row; justify-content: center;"
          >
            <div
              class="form disburse-form"
              style="display:flex; flex-direction: row; justify-content: center;"
            >
              <div class style="margin-right:30px">
                <button
                  class="btn btn--default delete_button"
                  data-dismis="modal"
                  aria-label="Close"
                  data-toggle="modal"
                  data-target="#createDeleteModal"
                >Cancel</button>
              </div>
              <div class>
                <button
                  v-if="enableActions"
                  class="btn btn--primary delete_button"
                  style="margin-bottom:15px;"
                  @click="DeleteBe(cardId)"
                  type="submit"
                  data-dismis="modal"
                  aria-label="Close"
                  data-toggle="modal"
                  data-target="#createDeleteModal"
                >Remove</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { getAllWalletsFundingHistory } from "../../utils/wallet-transactions/walletService";
import { fundWalletWithVoucher } from "../../utils/wallet-transactions/fundWalletService";
import { fundWalletWithRave } from "../../utils/wallet-transactions/fundWalletService";
import { fundWalletWithLinkedCard } from "../../utils/wallet-transactions/fundWalletService";
import { getCurrencyName } from "../../utils/wallet-transactions/transferService";
import { fundWalletWithWallet } from "../../utils/wallet-transactions/fundWalletService";
import { getWalletOverview, linkACard, deleteCard} from "../../utils/wallet-transactions/walletService";
import { createWallet } from "../../utils/wallet-transactions/walletService";
import ModalTemplate from '@/components/partials/ModalTemplate.vue';
import Datepicker from 'vuejs-datepicker';
import Cleave from 'vue-cleave-component';
console.log(Cleave)
// var cleave = new Cleave();


export default {
  created() {
    this.handleWalletOverview();
    this.handleCurrencyFetch();
  },

  data() {
    return {
      showModal: false,
      isLoading: true,
      walletOverviewData: {
        cashBalances: {
          value: "",
          empty: false
        },
        linkedCards: {
          value: "",
          empty: false
        },
        linkedBankAccounts: {
          value: "",
          empty: false
        }
      },
      createObject: {
        name: "",
        currency: "",
        countryTag: "",
        password: "",
        uref: ""
      },
      cardObject: {
        expiryDate: null,
        cardNumber: '',
        cvv: '',
      },
      options: {
        blocks: [4, 4, 4, 4],
        uppercase: true
      },
      options3: {
        blocks: [3],
        uppercase: true
      },
      options2: {
         date: true,
         datePattern: ['m', 'y']
      },
      currencyList: [],
      linkingNotFinished: true,
      linkingDone: false,
      linkingSuccessful: false,
      linkingFailed: false,
      linkingErrors: [],
      walletCurrencyList: null,
      walletToWallet: false,
      currencyResult: "",
      success: "",
      errorExists: false,
      createErrors: [],
      createDone:false,
      createFailure: false,
      createSuccess: false,
      cardId: '',
    };
  },
  components: {
    'modal-template':ModalTemplate,
    Datepicker,
    Cleave
  },
  methods: {
    handleCurrencyFetch() {
      let self = this;
      getCurrencyName()
      .then((response) => {
        if (response.status === 200) {
          self.currencyList.length = 0;
          response.data.data.forEach(currency => {
            self.currencyList.push({
              countryTag: currency.countryTag,
              shortCode: currency.shortCode,
              currencyName: currency.currencyName,
            });
          });
        }
      })
      .catch(error => {
        self.$Progress.fail();
      });
    },
    //return value to lower case
    toLowerCase(value) {
      let val = (value) ? value.toLowerCase() : ''
      return val;
    },
    getId(id) {
      this.cardId = id;
    },
    //clear all errors on form if select changes
    clearError(){
      this.errors.clear();
    },

    createWalletHandler() {
      this.currencyList.filter((currency) => {
        if (currency.countryTag === this.createObject.countryTag) this.createObject.currency = currency.shortCode;
      });

      let w = this.createObject;
      let app = this;

      createWallet(w.name, w.password, w.currency, w.uref, w.countryTag)
        .then(response => {
          console.log(response);
          if (response.status === 200) {
            this.utilityMethods().createSuccessful();
          }
        })
        .catch(error => {
          this.$Progress.fail();
          this.utilityMethods().createFailed(error.response.data.message || 'Unable to create Balance!');
          console.log(this.transactionErrors);
        });
    },
    handleLinkingCard(){
      this.$Progress.start();
      let data = {}
      if(data.card_no === '' || data.cvv === '' || data.expiry_year === '') this.linkingErrors.push('You must fill all fields');
      data.card_no = this.cardObject.cardNumber.toString();
      data.cvv = this.cardObject.cvv.toString();
      data.expiry_month = this.cardObject.expiryDate.substr(0,2);
      data.expiry_year = this.cardObject.expiryDate.substr(2);
      console.log(data)
      // data.expiry_month = data.expiry_month.toString();
      // data.expiry_year = data.expiry_year.toString();

      // if(data.expiry_month.length < 2) data.expiry_month = (0 + data.expiry_month);
      // data.expiry_year = data.expiry_year.substr( (data.expiry_year.toString().length-2) );
      // data.link_card = true;
      
      // if(data.cvv.length <3) this.linkingErrors.push('cvv must be 3 numbers'); 
      if(this.linkingErrors < 1){
        linkACard(data).then((response) => {
          this.$Progress.finish();
          console.log(response);
          this.linkingNotFinished = false;
          this.linkingDone = true;
          this.linkingSuccessful = true;
          this.linkingFailed = false;
        })
        .catch((error) => {
          this.$Progress.fail();
          this.linkingErrors.push(error.response.data.message || error.response.statusText);
          console.log(error.response);
          this.linkingNotFinished = false;
          this.linkingDone = true;
          this.linkingSuccessful = false;
          this.linkingFailed = true;
        })
      }
      else {
        this.$Progress.fail();
          this.linkingNotFinished = false;
          this.linkingDone = true;
          this.linkingSuccessful = false;
          this.linkingFailed = true;
      }
    },
    //handle wallet overview API
    handleWalletOverview() {
      //Call the voucher API
      let self = this;
      getWalletOverview().then(response => {
        if (response.status === 200) {
          this.isLoading = false;
          this.walletOverviewData.cashBalances.value = response.data.balances;
          this.walletOverviewData.linkedCards.value = response.data.cards;
          this.walletOverviewData.linkedBankAccounts.value =
            response.data.bank_accounts;

          if (
            Object.keys(self.walletOverviewData.cashBalances.value).length ===
              0 &&
            self.walletOverviewData.cashBalances.value.constructor === Object
          ) {
            this.walletOverviewData.cashBalances.empty = true;
            //empty wallet first before storage
            self.$store.commit("emptyPrimaryCurrencies");

            //commit wallets to localstorage
            self.walletOverviewData.cashBalances.forEach(wallet => {
              self.$store.commit("updatePrimaryWalletCurrencies", {
                currencyCode: wallet.currency.shortCode,
                countryName: wallet.currency.countryName,
                name: wallet.name,
                currencyId: wallet.id,
                currencyBalance: wallet.balance,
                currencyUref: wallet.uref,
                country: wallet.countryTag,
              });
            });
          }

          if (
            Object.keys(self.walletOverviewData.linkedCards.value).length ===
              0 &&
            self.walletOverviewData.linkedCards.value.constructor === Object
          ) {
            this.linkedCards.cashBalances.empty = true;
          }

          if (
            Object.keys(self.walletOverviewData.linkedBankAccounts.value)
              .length === 0 &&
            self.walletOverviewData.linkedBankAccounts.value.constructor ===
              Object
          ) {
            this.linkedCards.linkedBankAccounts.empty = true;
          }
        }
        if (this.$route.params.trigger === 'yes') {
          $("#createWalletModal").modal('toggle');
          if (this.$route.params.currency) {
            this.createObject.currency = this.$route.params.currency;
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
      window.scrollTo(0,0);
    },
    DeleteBe(id) {
      let self = this;
      self.$Progress.start();
      let submitBtn = document.getElementsByClassName("delete_button");
      submitBtn.disabled = true;
      console.log(id);
      deleteCard(id)
        .then(response => {
          self.$Progress.finish();
          self.handleWalletOverview();
        })
        .catch(error => {
          self.$Progress.fail();
          console.log(error);
        });
      $("#modalWindow").modal("hide");
      // this.$emit('close');
    },
    utilityMethods(){
      let self = this;
      return{
        triggerPageLoad(){
          self.$router.push('/wallet/balances/overview');
          location.reload()
        },
        createSuccessful(){
          self.createDone = true;
          self.createSuccess = true;
          self.createFailure = false;
          self.createErrors = [];
          self.clearError()
        },
         createFailed(error){
          self.$Progress.fail();
          self.createDone = true;
          self.createSuccess = false;
          self.createFailure = true;
          self.clearError()
          self.createErrors = [];
          self.createErrors.push(error)
        },
        triggerPageRefresh(){
          //close the modal, reset all data
          self.createDone = false;
          self.createErrors = [];
          self.createFailure = false;
          self.createSuccess = false;
          self.linkingNotFinished = true;
          self.linkingDone = false;
          self.linkingSuccessful = false;
          self.linkingFailed = false;
          self.linkingErrors = [];
          self.cardObject.expiryDate = '';
          self.cardObject.cardNumber = '';
          self.cardObject.cvv = '';
          self.clearError()
        },
        newLinking(whatIs = 'Done'){
          self.linkingNotFinished = true;
          self.linkingDone = false;
          self.linkingSuccessful = false;
          self.linkingFailed = false;
          self.linkingErrors = [];
          if(whatIs === 'Done'){
            self.cardObject.expiryDate = '';
            self.cardObject.cardNumber = '';
            self.cardObject.cvv = '';
          }
        }
      }
    },
  },

  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
    //get wallet currency list from store.
    walletList() {
      return JSON.parse(window.localStorage.getItem("walletList"));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wallet/WalletOverview.vue